// Re-export the shared types for compatibility
export type { TMDBMovie, TMDBResponse, TMDBMovieDetails } from '../types/movie.types'

// Image size options
export const IMAGE_SIZES = {
  poster: {
    small: 'w185',
    medium: 'w342',
    large: 'w500',
    original: 'original',
  },
  backdrop: {
    small: 'w300',
    medium: 'w780',
    large: 'w1280',
    original: 'original',
  },
  logo: {
    small: 'w92',
    medium: 'w185',
    large: 'w500',
    original: 'original',
  },
};

const TMDB_IMAGE_BASE_URL = 'https://image.tmdb.org/t/p';

/**
 * Build TMDB image URL with proper error handling
 */
export function getImageUrl(
  path: string | null,
  size: string = IMAGE_SIZES.poster.medium
): string {
  if (!path) {
    return '/placeholder-movie.png';
  }
  
  const imageUrl = `${TMDB_IMAGE_BASE_URL}/${size}${path}`;
  return imageUrl;
}

/**
 * Get placeholder image URL
 */
export function getPlaceholderImage(): string {
  return '/placeholder-movie.png';
}
